import React, { useEffect, useRef, useState } from "react";
import { Progress, Modal, Button, Row, Typography } from "antd";
import "./fileupload.scss";
import CloudUpload from "./../../assets/images/uploadIcon.svg";
import * as documentService from "./../../service/documentService";
import * as documentUtility from "./../../util/documentThumbUtility";
import { useStore } from "./../../store/store";
import {
  DeleteFilled,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Preview from "./../../common/preview/preview";
import { CommonConstants } from "../../constants/commonConstants";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import * as localStorageService from "../../service/localStorageService";
import Notification from "../../service/notification";

const { Text } = Typography;

const Fileupload = (props) => {
  const { user } = useStore();
  const { t } = useTranslation();
  const [uploadedFileThumb, setUploadedFileThumb] = useState(
    props?.defaultThumbFile
      ? documentUtility.getThumbnailImagePath(props?.defaultThumbFile)
      : ""
  );

  const [uploadedFile, setUploadedFile] = useState(
    props?.defaultFile ? props?.defaultFile : ""
  );
  const [fileName, setFileName] = useState(props?.fileName);
  const [isWaitUpload, setIsWaitUpload] = useState(false);
  const [uploadedProgress, setUploadedProgress] = useState(0);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);
  const fileuploadref = useRef(null);
  const uniqueId = props?.uniqueId;

  useEffect(() => {
    setUploadedFile(props?.defaultFile);
    setUploadedFileThumb(
      documentUtility.getThumbnailImagePath(props?.defaultThumbFile)
    );
  }, [props?.defaultThumbFile]);

  const handleUploadClick = () => {
    if (!props.readonly) {
      if (fileuploadref.current) {
        fileuploadref.current.click();
      } else {
        console.error("File input ref is not set.");
      }
    }
  };

  const deleteFile = () => {
    setUploadedFileThumb("");
    setFileName("");
    props.onChange({
      DocType: "",
      EntityId: "",
      FileName: "",
      FileThumbName: "",
      FileThumbURL: "",
      FileURL: "",
    });
  };

  const previewImage = () => {
    setIsPreviewModalOpen(true);
  };

  const downloadFile = () => {
    var imageUrl = uploadedFile; // Replace with your image URL
    var viewLink = document.createElement("a");
    viewLink.href = imageUrl;
    viewLink.target = "_blank"; // Opens in a new tab
    viewLink.download = uploadedFile.split("/").pop();
    document.body.appendChild(viewLink);
    viewLink.click();
    document.body.removeChild(viewLink);
  };

  const handleModalCancel = () => {
    setIsPreviewModalOpen(false);
  };

  var config = {
    onUploadProgress: function (progressEvent) {
      debugger;
      console.log(
        `progressEvent.loaded:${Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )}`
      );
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setUploadedProgress(percentCompleted);
    },
  };

  const handleUploadDragOver = (e) => {
    let event = e;
    event.stopPropagation();
    event.preventDefault();
    setIsDragActive(true);
  };

  const handleUploadDragEnd = (e) => {
    setIsDragActive(false);
  };

  const handleFileChange = (fileEvent) => {
    // alert(JSON.stringify(fileEvent))
    // debugger;
    if (fileEvent?.target?.files && fileEvent.target.files.length > 0) {
      let file = fileEvent.target.files[0];
      if (file) {
        uploadFile(file);
        // props.updateFormValue(file)
        // setFileName(file.name)
        // props.onChange({
        //     "DocType": file.type,
        //     "EntityId": file.entityId,
        //     "FileName": file.name,
        //     "FileThumbName": file.fileThumbName,
        //     "FileThumbURL": file.fileThumbURL,
        //     "FileURL": file.fileURL,
        //     'size': file.size,
        //     "Status" : isWaitUpload,
        //     "file":file
        // })
      }
    }
  };

  const handleUploadDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer && e.dataTransfer.files.length != 0) {
      var files = e.dataTransfer.files;
      let file = files[0];
      uploadFile(file);
      // props.updateFormValue(file)
      setFileName(file.name);
      props.onChange({
        DocType: file.type,
        EntityId: file.entityId,
        FileName: file.name,
        FileThumbName: file.fileThumbName,
        FileThumbURL: file.fileThumbURL,
        FileURL: file.fileURL,
        size: file.size,
        Status: isWaitUpload,
      });
    }
  };

  const uploadFile = (file) => {
    setIsDragActive(false);

    if (
      file.type == "image/png" ||
      file.type == "image/jpg" ||
      file.type == "image/jpeg" ||
      file.type == "application/pdf"
    ) {
      if (file.size < 10000 * 1000) {
        const form = new FormData();

        form.append("file", file);

        var payload = {
          docType: props?.filetype,
          entityType: props?.entityType,
          fileName: file.name,
          docName: file.name ? file.name.replace(" ", "_") : "",
          fileData: "",
          fileURL: "",
          fileThumbURL: "",
          fileThumbName: "",
          fileData: "",
          uniqueID: "",
          totalPartition: 1,
          seq: 1,
          isPathSet: true,
        };
        form.append("details", JSON.stringify(payload));

        setIsWaitUpload(true);

        documentService
          .uploadDocumentV2(form, config)
          .then((response) => {
            setIsWaitUpload(false);
            if (response.data.status === 200) {
              props.onChange({
                DocType: response.data.data.docType,
                EntityId: response.data.data.entityId,
                FileName: response.data.data.fileName,
                FileThumbName: response.data.data.fileThumbName,
                FileThumbURL: response.data.data.fileThumbURL,
                FileURL: response.data.data.fileURL,
                Status: isWaitUpload,
              });
              setUploadedFileThumb(response.data.data.fileThumbURL);
              setUploadedFile(response.data.data.fileURL);
              setUploadedProgress(0);
              // Notification.success('success', t("FILE_UPLOAD_SUCCESS"))
              Notification.success(
                t("SUCCESS_KEY"),
                t("FILE_UPLOADED_SUCCESS")
              );
            } else {
              // Notification.error(response.data.message);
            }
          })
          .catch((error) => {
            setIsWaitUpload(false);
            // Notification.error(t("ERROR_MESSAGE"))
          });
        // }
      } else {
        Notification.error(t("FILE_SIZE_ERROR"));
      }
    } else {
      Notification.error(t("FILE_UPLOAD_NOT_SUPPORTED"));
    }
  };

  return (
    <>
      {props.showDownload && uploadedFile && (
        <div
          style={{ cursor: "pointer", textAlign: "right", zIndex: 1 }}
          onClick={() => window.open(uploadedFile, "_blank")}
        >
          <Button
            size="small"
            type="default"
            icon={<DownloadOutlined />}
          ></Button>{" "}
        </div>
      )}
      <div className="file-upload-container">
        {uploadedFileThumb ? (
          <div
            style={{
              position: "relative",
              padding: "10px",
              cursor: "default",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              className="uploaded-file"
              src={uploadedFileThumb}
              onClick={previewImage}
              style={{
                cursor: "zoom-in",
                width: props.delete === false ? "100%" : "80%",
              }}
            />
            {/* <Row className='uploaded-file-row'>
                                {fileName &&
                                    <span>{fileName}</span>
                                }
                        </Row> */}
            {!props.readonly ? (
              <div
                className={
                  props.reUpload ? "icon-container" : "icon-container-center"
                }
              >
                {/* {!props.reUpload &&  */}
                {props.delete === false ? (
                  ""
                ) : (
                  <DeleteFilled onClick={deleteFile} className="delete-icon" />
                )}
                {props.reUpload && (
                  <div
                    onClick={handleUploadClick}
                    className={isDragActive ? "drag-active" : "content"}
                    style={{ padding: !props?.accessFile && "25px 10px" }}
                    onDragOver={(e) => {
                      handleUploadDragOver(e);
                    }}
                    onDragExit={(e) => {
                      handleUploadDragEnd(e);
                    }}
                    onDrop={(e) => {
                      handleUploadDrop(e);
                    }}
                  >
                    <UploadOutlined className="reupload-icon" />
                    <input
                      type="file"
                      onChange={handleFileChange}
                      ref={fileuploadref}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
                {/* <DownloadOutlined onClicks={downloadFile} className="download-icon"></DownloadOutlined> */}
              </div>
            ) : null}
          </div>
        ) : (
          <>
            {isWaitUpload ? (
              <div className="wait-container">
                <Progress
                  trailColor="white"
                  size={70}
                  strokeColor="#F99E00"
                  type="circle"
                  percent={uploadedProgress}
                />
              </div>
            ) : (
              <div
                onClick={handleUploadClick}
                className={isDragActive ? "drag-active" : "content"}
                style={{ padding: !props?.accessFile && "25px 10px" }}
                onDragOver={(e) => {
                  handleUploadDragOver(e);
                }}
                onDragExit={(e) => {
                  handleUploadDragEnd(e);
                }}
                onDrop={(e) => {
                  handleUploadDrop(e);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    justifyContent: "center",
                    width: "100%",
                    alignItems: "center",
                    padding: props?.accessFile && "10px 0",
                  }}
                >
                  <img src={CloudUpload} alt="Cloud Upload" />
                  <span className="upload-text">
                    <Text
                      className="upload-text"
                      style={{ width: "" }}
                      ellipsis={{ tooltip: true }}
                    >
                      {!props?.accessFile
                        ? `${t("KYC_CLICK_TO_UPLOAD")}`
                        : props?.name
                        ? `${t("KYC_UPLOAD_LBL")} ${props?.name}`
                        : `${t("KYC_UPLOAD_LBL")}`}
                    </Text>
                    {/* {t("KYC_DRAG_DROP")} */}
                  </span>
                </div>

                {/* {!props?.accessFile &&  */}
                {
                  <span className="file-size">
                    {t("KYC_ONLY")} PNG, JPG, JPEG, PDF ({t("KYC_MAX_SIZE")} -
                    10MB)
                  </span>
                }
                <input
                  type="file"
                  onChange={handleFileChange}
                  ref={fileuploadref}
                  style={{ display: "none" }}
                />
              </div>
            )}
          </>
        )}
      </div>

      <Modal
        title="Preview"
        open={isPreviewModalOpen}
        onCancel={handleModalCancel}
        centered
        footer={null}
        className="big-modal"
        style={{ width: "90%" }}
      >
        <Preview uploadedfile={uploadedFile}></Preview>
      </Modal>
    </>
  );
};

export default Fileupload;
